import React from 'react';
import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

const Circle = styled.div`
  width: 6px;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.secondaryText};
  content: '';
  border-radius: 50%;
`;

const DisclaimerCircle = () => {
  return (
    <Box inline>
      <Circle />
    </Box>
  );
};

export default DisclaimerCircle;
